// extracted by mini-css-extract-plugin
var _1 = "SharingDropdownRow-module__animatedBackground--ptiFB";
var _2 = "SharingDropdownRow-module__info--dN3Wd";
var _3 = "SharingDropdownRow-module__main--ddAgV";
var _4 = "SharingDropdownRow-module__role--ISchs";
var _5 = "SharingDropdownRow-module__row--qtw3e";
var _6 = "SharingDropdownRow-module__secondary--lWgwC";
export { _1 as "animatedBackground", _2 as "info", _3 as "main", _4 as "role", _5 as "row", _6 as "secondary" }
